var _circle, _circle2, _circle3, _circle4, _path, _path2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFeedback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 188,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.329,
    cy: 24.5,
    r: 13.5,
    fill: "#F6F6F7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.829,
    cy: 150,
    r: 10,
    fill: "#F6F6F7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.829,
    cy: 70,
    r: 8,
    fill: "#F6F6F7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.329,
    cy: 92.5,
    r: 73.5,
    fill: "#F6F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.392 56.25h-33.125a33.124 33.124 0 100 66.25h3.312v16.562l19.875-16.562h9.938a33.128 33.128 0 0033.125-33.125 33.125 33.125 0 00-33.125-33.125v0zM185.555 67.726l29.399 29.399",
    stroke: "#A5A5A5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164.657 76.313c16.284 0 29.485-13.201 29.485-29.485s-13.201-29.484-29.485-29.484-29.484 13.2-29.484 29.484c0 16.284 13.2 29.484 29.484 29.484z",
    stroke: "#A5A5A5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-feedback_svg__clip0_1341_817)",
    stroke: "#A5A5A5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.641 127.464c19.586 6.732 40.921-3.689 47.653-23.275 6.731-19.586-3.69-40.921-23.275-47.653-19.587-6.731-40.921 3.69-47.653 23.275-6.732 19.587 3.689 40.921 23.275 47.653z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.127 109.022a23.124 23.124 0 01-37.706-13.356m31.167-6.075a5 5 0 019.457 3.25m-33.1-11.376a5 5 0 119.457 3.25"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-feedback_svg__clip1_1341_817)",
    stroke: "#A5A5A5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.57 174.213c20-5.38 31.852-25.954 26.472-45.954-5.379-20-25.953-31.852-45.953-26.472-20 5.38-31.852 25.954-26.472 45.954 5.379 19.999 25.953 31.851 45.953 26.472z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.049 160.052a23.115 23.115 0 016.077-10.284 23.118 23.118 0 0122.343-5.786 23.118 23.118 0 0110.304 6.042M185.741 131.103a5 5 0 019.657-2.597m-33.798 9.091a4.998 4.998 0 017.324-5.631 4.998 4.998 0 012.332 3.033"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-feedback_svg__clip0_1341_817"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(18.968 -110.227 98.415)",
    d: "M0 0h80v80H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-feedback_svg__clip1_1341_817"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-15.055 480.72 -440.077)",
    d: "M0 0h80v80H0z"
  })))));
}
export default SvgIconFeedback;